import { render, staticRenderFns } from "./AppListItemGroup.vue?vue&type=template&id=496e2084"
import script from "./AppListItemGroup.vue?vue&type=script&lang=js"
export * from "./AppListItemGroup.vue?vue&type=script&lang=js"
import style0 from "./AppListItemGroup.vue?vue&type=style&index=0&id=496e2084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports